var bulletTexts1 = [];
        $('#details-swiper-1 .swiper-pagination-bullet').each(function() {
            bulletTexts1.push($(this).text());
        });

        var ap24Swiper1 = new Swiper('#details-swiper-1', {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            loop: true,
            navigation: {
                nextEl: '#details-swiper-1 .swiper-button-next',
                prevEl: '#details-swiper-1 .swiper-button-prev',
            },
            pagination: {
                el: '#details-swiper-1 .swiper-pagination',
                clickable: true,
                renderBullet: function(index, className) {
                    return '<p class="' + className + '">' + bulletTexts1[index] + '</p>';
                }
            },
            on: {
                slideChange: function() {
                    const pagination = document.querySelector('#details-swiper-1 .swiper-pagination');
                    const activeBullet = pagination?.querySelector('.swiper-pagination-bullet-active');
                    if (!activeBullet) return;

                    // 计算精确滚动位置（居中显示）
                    const containerWidth = pagination.offsetWidth;
                    const bulletOffset = activeBullet.offsetLeft;
                    const bulletWidth = activeBullet.offsetWidth;
                    const targetScroll = bulletOffset - (containerWidth / 2) + (bulletWidth / 2);

                    // 平滑滚动（带边界检查）
                    smoothScrollTo(pagination, targetScroll, 300);
                }
            }
        });

        // 优化后的平滑滚动函数
        function smoothScrollTo(element, target, duration) {
            const start = element.scrollLeft;
            const maxScroll = element.scrollWidth - element.clientWidth;
            const clampedTarget = Math.max(0, Math.min(target, maxScroll));
            const change = clampedTarget - start;
            const startTime = performance.now();

            function animateScroll(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                element.scrollLeft = start + change * easeInOutQuad(progress);
                if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                }
            }

            // 缓动函数（更自然的动画）
            function easeInOutQuad(t) {
                return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
            }

            requestAnimationFrame(animateScroll);
        }




var bulletTexts2 = [];
        $('#details-swiper-2 .swiper-pagination-bullet').each(function() {
            bulletTexts2.push($(this).text());
        });

        var ap24Swiper2 = new Swiper('#details-swiper-2', {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            loop: true,
            navigation: {
                nextEl: '#details-swiper-2 .swiper-button-next',
                prevEl: '#details-swiper-2 .swiper-button-prev',
            },
            pagination: {
                el: '#details-swiper-2 .swiper-pagination',
                clickable: true,
                renderBullet: function(index, className) {
                    return '<p class="' + className + '">' + bulletTexts2[index] + '</p>';
                }
            },
        });





var ap24Swiper3 = new Swiper('#details-swiper-3', {
    autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            loop: true,
            spaceBetween: 20,
            pagination: {
                el: '#details-swiper-3 .swiper-pagination',
                clickable: true,
            }
        });



// 设置初始高度函数
    function setInitialHeight() {
        const $overflow = $('.overflo_y');
        let initialHeight;
        
        if (window.matchMedia('(max-width: 520px)').matches) {
            initialHeight = '450px';
        } else if (window.matchMedia('(max-width: 800px)').matches) {
            initialHeight = '485px';
        } else if (window.matchMedia('(max-width: 1320px)').matches) {
            initialHeight = '500px';
        } else {
            initialHeight = '600px'; // 默认值
        }
        
        $overflow.css('height', initialHeight);
    }

    // 页面加载时设置初始高度
    $(document).ready(function() {
        setInitialHeight();
        $('.specifications-learn-more img').css({
            'transform': 'rotate(0deg)',
            'transition': 'transform 0.5s ease'
        });
    });

    // 窗口大小改变时重新设置初始高度
    $(window).resize(function() {
        setInitialHeight();
    });

    // 点击事件
    $('.specifications-learn-more').click(function() {
        const $overflow = $('.overflo_y');
        const $arrow = $('.specifications-learn-more img');
        
        if ($overflow.css('height') !== $overflow[0].scrollHeight + 'px') {
            // 展开内容
            $overflow.css('height', $overflow[0].scrollHeight + 'px');
            $arrow.css('transform', 'rotate(180deg)');
        } else {
            // 收起内容
            setInitialHeight(); // 恢复到响应式初始高度
            $arrow.css('transform', 'rotate(0deg)');
        }
    });

















